import {IOnlineCondolenceDetails} from '../../types/resources/OnlineCondolenceDetails';
import {useSettingsContext} from '../../context/settings/useSettingsContext';
import {useTranslation} from 'react-i18next';
import styled from 'styled-components';
import DateUtils from '../../utils/DateUtils';

const Links = styled.div`
    @media (max-width: 768px) {
        && {
            flex-wrap: wrap;
            //justify-content: flex-start;
        }
    }
`

const ButtonLink = styled.a.attrs({
    className: 'cr-pill cr-border-primary cr-text-primary',
})`
    text-align: left;
`

const AlertButtonLink = styled.a.attrs({
    className: 'cr-pill cr-text-white cr-bg-alert',
})`
    text-align: left;
`

type TProps = {
    details: IOnlineCondolenceDetails;
}

const ActionLinks = ({details}: TProps) => {
    const {t} = useTranslation();
    const { sendFlowersUrl } = useSettingsContext();

    const showMourningMessage =
        details.mourningMessageFileUrl
        && DateUtils.isNowBetween(details.mourningMessageFileVisibleFrom)
    ;

    const showObituary =
        details.obituaryFileUrl
        && DateUtils.isNowBetween(details.obituaryFileVisibleFrom)
    ;

    const showMemorialCard =
        details.memorialCardFileUrl
        && DateUtils.isNowBetween(details.memorialCardFileVisibleFrom)
    ;

    const showDigitalMourningCard =
        details.digitalMourningCardFileUrl
        && DateUtils.isNowBetween(details.digitalMourningCardFileVisibleFrom)
    ;

    const hasLinks = (
        sendFlowersUrl
        || showMourningMessage
        || showObituary
        || showMemorialCard
        || details.donationUrl
        || details.liveStreamUrl
        || showDigitalMourningCard
    );

    return hasLinks ? (
        <Links className="cr-action-links cr-flex cr-gap cr-center cr-px-lg cr-py">
            {showMourningMessage
                && <ButtonLink className={'cr-mourning-card'} href={details.mourningMessageFileUrl}>{t('mourning-card')}</ButtonLink>
            }
            {showObituary
                && <ButtonLink className={'cr-obituary-card'} href={details.obituaryFileUrl}>{t('obituary-card')}</ButtonLink>
            }
            {showDigitalMourningCard
                && <ButtonLink className={'cr-digital-mourning-card'} href={details.digitalMourningCardFileUrl}>{t('digital-mourning-card')}</ButtonLink>
            }
            {showMemorialCard
                && <ButtonLink className={'cr-memorial-card'} href={details.memorialCardFileUrl}>{t('memorial-card')}</ButtonLink>
            }
            {sendFlowersUrl
                && <ButtonLink className={'cr-send-flowers'} href={sendFlowersUrl}>{t('send-flowers')}</ButtonLink>
            }
            {details.donationUrl
                && <ButtonLink className={'cr-donate'} href={details.donationUrl}>{t('donate')}</ButtonLink>
            }
            {details.liveStreamUrl
                && <AlertButtonLink className={'cr-view-livestream'} href={details.liveStreamUrl}>{t('view-livestream')}</AlertButtonLink>
            }
        </Links>
    ) : null;
}

export default ActionLinks;
